import { useContext, useMemo } from "react";
import contextBabylon from "../../../../context/index.js";
export const useOriginInput = ({ name ='origin' , label , icon ='marker' , limit , types , type , defaultValue , validate , disabled , literals , geolocation =false , queryParams  })=>{
    const { Language  } = useContext(contextBabylon);
    const finalTypes = useMemo(()=>{
        const finalTypes = [
            ...types ?? []
        ];
        if (type && !types?.length) {
            finalTypes.push(type);
        }
        return finalTypes;
    }, [
        type,
        types
    ]);
    const endpoint = useMemo(()=>({
            url: 'https://autocomplete.toolfactory.tech/query',
            queryParams: {
                language: Language?.toLowerCase() ?? 'es',
                format: 'json',
                n: limit ?? 20,
                type: finalTypes,
                geolocation,
                ...queryParams
            }
        }), [
        Language,
        limit,
        finalTypes,
        geolocation,
        queryParams
    ]);
    return useMemo(()=>({
            name,
            label,
            icon,
            defaultValue,
            endpoint,
            isHiddenRequired: true,
            validate,
            disabled,
            literals
        }), [
        defaultValue,
        disabled,
        endpoint,
        icon,
        label,
        literals,
        name,
        validate
    ]);
};
export default useOriginInput;

//# sourceMappingURL=useOriginInput.js.map